<template>
  <div class="receiveManage column-me">
    <div class="tab-div row-me">
      <div class="tab-item column-me row-center" @click="clickTab(0)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===0}">待接方列表</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===0}"></div>
      </div>
      <div class="tab-item column-me row-center" @click="clickTab(1)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===1}">接方查询</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===1}"></div>
      </div>
      <div class="tab-item column-me row-center" @click="clickTab(2)" v-if="canOperate">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===2}">录入处方</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===2}"></div>
      </div>
    </div>

    <!--待接方列表、接方查询-->
    <div class="card-div column-me flex1" v-show="tabIndex===0 ||tabIndex===1">
      <div class="row-me row-center flex-wrap">
        <div class="width180">
          <el-input placeholder="处方订单号" style="width: 100%;" clearable v-model="number"></el-input>
        </div>
        <div class="width150 margin-left10">
          <el-input placeholder="患者姓名" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="width150 margin-left10">
          <el-select placeholder="医院名称" style="width: 100%;" filterable clearable v-model="hospital">
            <el-option v-for="item in hospitalArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width120 margin-left10">
          <el-input placeholder="机构名称" style="width: 100%;" clearable v-model="organization"></el-input>
        </div>
        <div class="width130 margin-left10" v-if="tabIndex===1">
          <el-select placeholder="处方状态" style="width: 100%;" filterable clearable v-model="selectState">
            <el-option v-for="item in stateArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width130 margin-left10" v-if="tabIndex===1">
          <el-select placeholder="日期类型" style="width: 100%;" filterable clearable v-model="selectDateType">
            <el-option v-for="item in [{id:0,name:'传方日期'},{id:1,name:'操作日期'}]" :key="item.id" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width300 margin-left10">
          <el-date-picker type="daterange" range-separator="-" start-placeholder="开始日期"
                          end-placeholder="结束日期" value-format="YYYY-MM-DD" clearable v-model="selectDate">
          </el-date-picker>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="row-me row-center margin-right10" v-if="tabIndex===0&&canOperate">
          <div class="btn-green width120 btn-height40" @click="clickPass">接方通过</div>
          <div class="btn-red width120 btn-height40 margin-left10" @click="clickDelete">接方作废</div>
        </div>
        <div class="btn-blank width120 btn-height40 margin-right10" @click="clickAddRemark" v-if="canOperate">
          添加备注
        </div>
        <div class="btn-blank width120 btn-height40" @click="clickPrintTransfer">打印调配单</div>
        <div class="btn-blank width140 btn-height40 margin-left10" @click="clickPrintBarCode">打印调配条码</div>
        <div class="btn-blank width120 btn-height40 margin-left10" @click="clickPrintLabel">打印标签</div>
        <div class="btn-blank width120 btn-height40 margin-left10" @click="clickExport">导出处方</div>
        <div class="btn-blank width120 btn-height40 margin-left10" @click="clickExportMedicine">导出药品</div>
        <div class="btn-blank width150 btn-height40 margin-left10" @click="clickExportAll">导出处方及药品</div>
      </div>
      <div class="column-me flex1 margin-top20 overflow-auto">
        <div class="flex1 overflow-auto">
          <el-table :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style" @selection-change="selectionChange"
                    @row-click='rowClick' :row-class-name="tableRowClassName" height="100%">
            <el-table-column type="selection" align="center" width="50"></el-table-column>
            <el-table-column prop="orderNo" label="处方订单号" align="center" width="250">
              <template v-slot="scope">
                <div class="row-me row-center height100Per">
                  <div class="flex1">{{ scope.row.orderNo }}</div>
                  <div class="red-point margin-left5" v-if="tabIndex===0&&!scope.row.isClick"></div>
                  <div class="red-point1 margin-left5" v-else></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="hospitalName" label="医院名称" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="mechName" label="机构名称" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="prescriptionNumber" label="医院单号" align="center" width="200"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="patientName" label="患者姓名" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="处方类型" align="center" width="100" show-overflow-tooltip>
              <template v-slot="scope">
                {{ scope.row.type === 0 ? '中药处方' : scope.row.type === 1 ? '中医外治' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="processType" label="加工类型" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="isDecoction" label="是否代煎" align="center" width="100">
              <template #default='scope'>
                <div v-if="scope.row.val === 't' || scope.row.val === 'd' || scope.row.val === 'z'">
                  {{ scope.row.isDecoction ? '代煎' : '自煎' }}
                </div>
                <div v-else>代煎</div>
              </template>
            </el-table-column>
            <el-table-column prop="packageNums" label="包装量" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="doseNums" label="剂数" align="center" width="80"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="frequency" label="次数" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="takeMethod" label="服用方法" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="decoctSchemeContent" label="煎药方案" align="center" width="250"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="mergeOrderNo" label="合单工单号" align="center" width="200"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="医生手签" align="center" width="130">
              <template #default='scope'>
                <el-image :src="scope.row.doctorSignature" :preview-src-list="[scope.row.doctorSignature]"
                          fit="scale-down" class="img-sign" hide-on-click-modal>
                  <template #error>
                    <img src="../../assets/img/no_img_small.png" slot="error"
                         class="width100Per height100Per objScaleDown">
                  </template>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="传方备注" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="传方时间" align="center" width="220"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="处方状态" align="center" width="100"
                             show-overflow-tooltip>
              <template #default='scope'>
                <div v-if="this.$method.isEmpty(scope.row.jieStatus)">待接方</div>
                <div v-if="scope.row.jieStatus===1">接方通过</div>
                <div v-if="scope.row.jieStatus===0">接方作废</div>
              </template>
            </el-table-column>
            <el-table-column prop="jieOperatorTime" label="操作时间" align="center" width="220"
                             show-overflow-tooltip v-if="tabIndex===1"></el-table-column>
            <el-table-column prop="jieOperator" label="操作人" align="center" width="120"
                             show-overflow-tooltip v-if="tabIndex===1"></el-table-column>
            <el-table-column prop="jieRemark" label="接方备注" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="receiveName" label="收件人" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="收件人地址" align="center" width="180" show-overflow-tooltip>
              <template #default='scope'>
                {{ scope.row.receiveProvince }}{{ scope.row.receiveCity }}
                {{ scope.row.receiveRegion }}{{ scope.row.receiveAddress }}
              </template>
            </el-table-column>
            <el-table-column prop="receiveMobile" label="收件电话" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="配送方式" align="center" width="130"
                             show-overflow-tooltip>
              <template #default='scope'>
                <div class="row-me center-all">
                  <div>{{ scope.row.deliveryCompany }}</div>
                  <div v-if="scope.row.deliveryType===0">(寄付)</div>
                  <div v-if="scope.row.deliveryType===1">(到付)</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!--录入处方-->
    <div class="card-div column-me flex1" v-show="tabIndex===2">
      <div class="flex1 overflow-auto">
        <div id="inputScrollDiv">
          <div class="row-me">
            <div class="column-me flex1">
              <div class="title1">医院信息</div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>医院名称：</div>
                <div class="flex1">
                  <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                             v-model="detailItem.hospitalName" @change="getHouseList">
                    <el-option v-for="item in hospitalArray" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>开方医生：</div>
                <div class="flex1">
                  <el-input placeholder="请输入" style="width: 100%;" clearable maxlength="100"
                            v-model="detailItem.doctorName"></el-input>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div">机构名称：</div>
                <div class="flex1">
                  <el-input placeholder="请输入" style="width: 100%;" clearable v-model="detailItem.mechName"
                            maxlength="100"></el-input>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div">医院单号：</div>
                <div class="flex1">
                  <el-input placeholder="请输入" style="width: 100%;" clearable
                            v-model="detailItem.prescriptionNumber" maxlength="100"></el-input>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div">所在科室：</div>
                <div class="flex1">
                  <el-input placeholder="请输入" style="width: 100%;" clearable maxlength="100"
                            v-model="detailItem.department"></el-input>
                </div>
              </div>
              <div class="row-me margin-top20">
                <div class="left-div">处方备注：</div>
                <div class="flex1">
                  <el-input placeholder="请输入" style="width: 100%;" clearable v-model="detailItem.remark"
                            maxlength="500" type="textarea" show-word-limit :autosize="autosize"></el-input>
                </div>
              </div>
            </div>
            <div class="line-grey-shu"></div>
            <div class="column-me flex1">
              <div class="title1">患者信息</div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>患者姓名：</div>
                <div class="flex1">
                  <el-input placeholder="请输入" style="width: 100%;" clearable maxlength="100"
                            v-model="detailItem.patientName"></el-input>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>年龄：</div>
                <div class="flex1">
                  <el-input placeholder="请输入" style="width: 100%;" clearable
                            @input="detailItem.patientAge=this.$method.checkInput(detailItem.patientAge,0)"
                            v-model="detailItem.patientAge"></el-input>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>性别：</div>
                <div class="flex1">
                  <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                             v-model="detailItem.patientSex">
                    <el-option v-for="item in [{id:1,name:'男'},{id:2,name:'女'}]" :key="item.id" :label="item.name"
                               :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div">手机号：</div>
                <div class="flex1">
                  <el-input placeholder="请输入" style="width: 100%;" clearable
                            @input="detailItem.patientMobile=this.$method.checkInput(detailItem.patientMobile,0)"
                            v-model="detailItem.patientMobile"></el-input>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>配送方式：</div>
                <div class="flex1">
                  <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                             v-model="detailItem.deliveryCompany">
                    <el-option v-for="item in companyArray"
                               :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>运费方式：</div>
                <div class="flex1">
                  <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                             v-model="detailItem.deliveryType">
                    <el-option v-for="item in [{id:0,name:'寄付'},{id:1,name:'到付'}]" :key="item.id"
                               :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div">收件人：</div>
                <div class="flex1">
                  <el-input placeholder="请输入" style="width: 100%;" clearable
                            v-model="detailItem.receiveName"></el-input>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div">收件电话：</div>
                <div class="flex1">
                  <el-input placeholder="请输入" style="width: 100%;" clearable
                            @input="detailItem.receiveMobile=this.$method.checkInput(detailItem.receiveMobile,0)"
                            maxlength="11" v-model="detailItem.receiveMobile"></el-input>
                </div>
              </div>
              <div class="row-me margin-top20">
                <div class="left-div">收件地址：</div>
                <div class="flex1 column-me">
                  <div class="row-me row-center">
                    <div class="flex1">
                      <el-select v-model="detailItem.receiveProvince" placeholder="请选择省" style="width: 100%;"
                                 filterable clearable @change="provinceChange">
                        <el-option v-for="item in provinceArray" :key="item.id" :label="item.n"
                                   :value="item.n">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="flex1 margin-left10">
                      <el-select v-model="detailItem.receiveCity" placeholder="请选择市" style="width: 100%;" filterable
                                 clearable @change="cityChange">
                        <el-option v-for="item in cityArray" :key="item.id" :label="item.n" :value="item.n">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="flex1 margin-left10">
                      <el-select v-model="detailItem.receiveRegion" placeholder="请选择区/县" style="width: 100%;"
                                 filterable clearable>
                        <el-option v-for="item in areaArray" :key="item.id" :label="item.n" :value="item.n">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="flex1 margin-top10">
                    <el-input placeholder="请输入详细地址" style="width: 100%;" clearable
                              v-model="detailItem.receiveAddress" maxlength="50"></el-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="line-grey-shu"></div>
            <div class="column-me flex1 padding-right20">
              <div class="title1">处方信息</div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>加工类型：</div>
                <div class="flex1">
                  <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                             v-model="detailItem.processType" @change="processTypeChange">
                    <el-option v-for="item in processTypeArray" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row-me row-center margin-top20"
                   v-if="detailItem.processType&&detailItem.processType.indexOf('汤剂')===-1">
                <div class="left-div"><span class="red-star">*</span>包装类型：</div>
                <div class="flex1">
                  <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                             v-model="detailItem.packageType">
                    <el-option v-for="item in packageTypeArray" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>剂数：</div>
                <div class="flex1">
                  <el-input placeholder="请输入" style="width: 100%;" clearable v-model="detailItem.doseNums"
                            @input="detailItem.doseNums=this.$method.checkInputZero(detailItem.doseNums,0)"></el-input>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>用法：</div>
                <div class="flex1">
                  <el-select placeholder="请选择" style="width: 100%;" filterable clearable v-model="detailItem.way1">
                    <el-option v-for="item in wayArray1" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </div>
                <div class="flex1 margin-left10">
                  <el-select placeholder="请选择" style="width: 100%;" filterable clearable v-model="detailItem.way2">
                    <el-option v-for="item in wayArray2" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>是否代煎：</div>
                <div class="flex1">
                  <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                             v-model="detailItem.isDecoctionShow">
                    <el-option v-for="item in [{id:0,name:'代煎'},{id:1,name:'自煎'}]" :key="item.id"
                               :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>包装量：</div>
                <div class="flex1">
                  <el-input placeholder="请输入，如分装2g、普煎200ml" style="width: 100%;" clearable
                            v-model="detailItem.packageNums"></el-input>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div"><span class="red-star">*</span>次数：</div>
                <div class="flex1">
                  <el-input placeholder="请输入，如每日2次" style="width: 100%;" clearable
                            v-model="detailItem.frequency"></el-input>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div">煎药方案：</div>
                <div class="flex1">
                  <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                             v-model="detailItem.decoctSchemeId">
                    <el-option v-for="item in planArray" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="row-me row-center margin-top20">
                <div class="left-div">下单时间：</div>
                <div class="flex1">
                  <el-date-picker v-model="detailItem.createTime" type="datetime" placeholder="请选择"
                                  style="width: 100%;" format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss"
                                  :disabled-date="disabledDate" :disabled-hours="disabledHour"
                                  :disabled-minutes="disabledMinute"/>
                </div>
              </div>
            </div>
          </div>
          <div class="line-grey-heng margin-top20"></div>
          <div class="title1 margin-top20">药品信息</div>
          <div class="width500 margin-top20">
            <el-select placeholder="请选择库房" style="width: 100%;" filterable clearable
                       v-model="detailItem.pharmacyId"
                       @change="getPharmacyDrug">
              <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="width500 margin-top20">
            <el-autocomplete
                :ref="'focusDrug'"
                class="width100Per"
                v-model="detailItem.searchDrug"
                suffix-icon="el-icon-arrow-down"
                slot="reference"
                placement="top-start"
                :fetch-suggestions="searchDrug"
                placeholder="请输入名称、简码搜索药品"
                :trigger-on-focus="true"
                :debounce="0"
                :highlight-first-item="false"
                @select="(item)=>clickSelectDrug(item)"
                :title="detailItem.drugInputDisabled?'药品加载中，请稍后':''"
                :disabled="detailItem.drugInputDisabled">
              <template #default="{ item }">
                <div class="row-me" v-if="item.index===0">
                  <div class="search-drug-title">药品名称</div>
                  <div class="search-drug-title">规格</div>
                  <div class="search-drug-title">简码</div>
                </div>
                <div class="row-me">
                  <div class="search-drug-content">{{ item.name }}</div>
                  <div class="search-drug-content">{{ item.spec }}</div>
                  <div class="search-drug-content">{{ item.pyName }}</div>
                </div>
              </template>
            </el-autocomplete>

          </div>
          <div class="row-me row-center flex-wrap margin-top20">
            <div class="item-drug column-me column-center" v-for="(item,index) in detailItem.drugs" :key="index">
              <div>{{ item.name }}</div>
              <div class="row-me row-center margin-top10">
                <div class="width120">
                  <el-input placeholder="请输入" style="width: 100%;" clearable v-model="item.nums"
                            @input="item.nums=this.$method.checkInput(item.nums,2)"></el-input>
                </div>
                <div class="margin-left10">{{ item.unit }}</div>
                <div class="width150 margin-left10">
                  <el-select placeholder="请选择" style="width: 100%;" filterable clearable
                             v-model="item.processMethod">
                    <el-option v-for="item in wayArray" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <img src="../../assets/img/delete.png" class="img-delete" @click="detailItem.drugs.splice(index,1)">
            </div>
          </div>
        </div>
      </div>
      <div class="row-me row-center flex-end1 padding-top20">
        <div class="btn-blue width100 btn-height40" @click="clickSavePre">保存</div>
        <div class="btn-blank width130 btn-height40 margin-left10" @click="clickSaveAndReceive">保存并接方</div>
        <div class="btn-blank width130 btn-height40 margin-left10" @click="clickImportPre" v-if="false">批量导入处方
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClearAll">清空</div>
      </div>
    </div>


    <!-- 接方作废 -->
    <el-dialog title="接方作废" v-model="visibleDelete" width="40%" :destroy-on-close="true">
      <deleteFang :ids="ids" source="接方"></deleteFang>
    </el-dialog>

    <!-- 接方详情 -->
    <el-dialog v-model="visibleDetail" width="95%" :before-close="beforeClose" :destroy-on-close="true" top="3vh"
               custom-class="detail-fang">
      <template #title>
        <div class="row-me row-center">
          <div class="dialog-title">{{ selectItem.orderNo }}&emsp;{{ selectItem.patientName }}</div>
          <div class="btn-next row-me center-all" @click="clickLeft">
            <el-icon color="#FFFFFF" style="margin-right: 0;">
              <arrowleft/>
            </el-icon>
            <span>上一个</span>
          </div>
          <div class="btn-next row-me center-all" @click="clickRight">
            <span>下一个</span>
            <el-icon color="#FFFFFF" style="margin-right: 0;">
              <arrowright/>
            </el-icon>
          </div>
        </div>
      </template>
      <fangDetail :id="selectItem.id"></fangDetail>
    </el-dialog>

    <!-- 批量导入处方 -->
    <el-dialog title="批量导入处方" v-model="visibleImport" width="40%" top="10vh" :destroy-on-close="true">
      <importPre name='批量导入处方模板' :downloadUrl="downloadUrl"></importPre>
    </el-dialog>

    <!-- 添加备注 -->
    <el-dialog title="添加备注" v-model="visibleRemark" width="820px" top="20vh" :destroy-on-close="true">
      <div class="padding10-20">
        <div class="flex1">
          <el-input type="textarea" placeholder="请输入备注" style="width: 100%;" clearable v-model="remark"
                    maxlength="500" show-word-limit rows="10"></el-input>
        </div>
        <div class="row-me row-center flex-end1 margin-top40">
          <div class="btn-blank width100 btn-height40" @click="visibleRemark=false">取消</div>
          <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSaveRemark">保存</div>
        </div>
      </div>
    </el-dialog>

    <!-- 打印调配单 -->
    <div v-show="false" v-if="ids&&ids.length>0">
      <printPrescription ref="printPage" :ids="ids"></printPrescription>
    </div>

    <!-- 打印调配码 -->
    <el-drawer v-model="showCodeDrawer" title="打印调配条码" direction="rtl" :destroy-on-close="true">
      <printTransferCode :persons="selectOrderArray"></printTransferCode>
    </el-drawer>

    <!-- 打印标签 -->
    <el-drawer v-model="showLabelDrawer" title="打印标签" direction="rtl" :destroy-on-close="true">
      <printLabel :persons="selectOrderArray"></printLabel>
    </el-drawer>


  </div>
</template>

<script>
import deleteFang from './deleteFang.vue'
import fangDetail from './fangDetail.vue'
import importPre from './importPre'
import printPrescription from './printPrescription.vue'
import printTransferCode from './printTransferCode.vue'
import printLabel from './printLabel.vue'
import cityData from '../../assets/js/citys.js'

export default {
  components: {
    deleteFang,
    fangDetail,
    importPre,
    printPrescription,
    printTransferCode,
    printLabel,
  },
  data() {
    let that = this
    return {
      tabIndex: 0,
      number: '',
      name: '',
      hospital: '',
      hospitalArray: [],
      selectState: '',
      stateArray: [{id: 12, name: '接方作废'}, {id: 15, name: '接方通过'}],
      selectDateType: 0,
      organization: '',
      selectDate: [],
      tableData: [],
      pageNo: 1,
      total: 0,
      visibleDelete: false,
      visibleDetail: false,
      selectItem: {}, //选择的处方
      ids: [], //选择框选择的id
      detailItem: {
        patientSex: '男',
        isDecoctionShow: '代煎',
        deliveryType: 1,
        drugs: [],
        drugInputDisabled: true,
      },
      processTypeArray: [
        {id: 0, name: '汤剂'}, {id: 0, name: '膏剂'}, {id: 0, name: '散剂'}, {id: 0, name: '颗粒剂'},
        {id: 0, name: '中医外治'}, {id: 0, name: '丸剂-水丸'}, {id: 0, name: '丸剂-大蜜丸'},
        {id: 0, name: '丸剂-水蜜丸'}, {id: 0, name: '丸剂-浓缩丸'},
      ],//剂型
      packageTypeArray: [],//包装类型
      visibleImport: false,
      downloadUrl: '', //导入模板下载链接
      visibleRemark: false,
      remark: '',
      showCodeDrawer: false,
      showLabelDrawer: false,
      selectOrderArray: [],//选择的患者
      wayArray1: [],
      wayArray2: [],
      planArray: [],//煎药方案下拉
      houseArray: [],//库房下拉
      wayArray: [],//药品煎药方式下拉
      disabledDate: function (time) {
        return time.getTime() > new Date(that.$method.getNowTime()).getTime();
      },
      disabledHour: function () {
        let selectDate = that.detailItem.createTime.split(' ')[0]
        if (selectDate === that.$method.getNowDate()) {
          return Array.from({
            length: 24 - Number(that.$method.getNowHour())
          }, (v, i) => i + 1 + Number(that.$method.getNowHour()));
        } else {
          return []
        }
      },
      disabledMinute: function () {
        let selectTime = that.detailItem.createTime.split(' ')[1]
        let nowTime = that.$method.getNowTime().split(' ')[1]
        if (selectTime.split(':')[1] === nowTime.split(':')[1]) {
          return Array.from({
            length: 60 - Number(that.$method.getNowMinute())
          }, (v, i) => i + 1 + Number(that.$method.getNowMinute()));
        } else {
          return []
        }
      },
      drugArray: [],//药品下拉
      autosize: {
        minRows: 2,
        maxRows: 7,
      },
      isSaving: false,//是否保存中
      canOperate: false,
      companyArray: [],//快递公司下拉
      provinceArray: [],
      cityArray: [],
      areaArray: [],
    }
  },
  // html加载完成之前
  created() {
    this.provinceArray = cityData
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.pageNo = 1
    this.getData()
    this.getHospitalArray()
  },
  // html加载完成后执行。
  mounted() {
    let index = this.$route.query.index
    if (!this.$method.isEmpty(index)) {
      this.clickTab(Number(index))
    }
  },
  // 事件方法执行
  methods: {
    clickTab(index) {
      this.tabIndex = index
      if (this.tabIndex === 0 || this.tabIndex === 1) {
        this.clickSearch()
      } else {
        this.getDict()
        this.getDelivery()
        this.detailItem.createTime = this.$method.getNowTime()
        this.isSaving = false
      }
    },
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    clickClear() {
      this.number = ''
      this.name = ''
      this.hospital = ''
      this.organization = ''
      this.selectState = ''
      this.selectDateType = 0
      this.selectDate = []
      this.pageNo = 1
      this.getData()
    },
    //加工类型改变
    processTypeChange(e) {
      this.detailItem.decoctSchemeId = ''
      this.planArray = []
      this.getPlanArray()
      this.getPackageType()
    },
    //选择
    selectionChange(e) {
      this.selectOrderArray = e
      let ids = []
      for (let item of e) {
        ids.push(item.id)
      }
      this.ids = ids
    },
    //赋值每一行的下标
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex;
    },
    //某一行点击
    rowClick(row, column, event) {
      if (column.no !== 0 && column.no !== 1 && column.no !== 15) {
        this.selectItem = row
        this.visibleDetail = true
      }
    },
    beforeClose(done) {
      this.getData()
      done()
    },
    //上一个
    clickLeft() {
      let index = this.selectItem.index
      if (index > 0) {
        index--
      } else {
        this.$message.error('已经是当前页的第1条')
      }
      this.selectItem = this.tableData[index]
    },
    //下一个
    clickRight() {
      let index = this.selectItem.index
      if (index < this.tableData.length - 1) {
        index++
      } else {
        this.$message.error('已经是当前页的最后一条')
      }
      this.selectItem = this.tableData[index]
    },
    //接方通过
    clickPass() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      this.$confirm("您确定要通过吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/order/receive', {
          ids: this.ids,
          pass: true,
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.pageNo = 1
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //接方作废
    clickDelete() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      this.visibleDelete = true
      this.bus.$off('deleteFangSuccess')
      this.bus.$on('deleteFangSuccess', res => {
        this.visibleDelete = false
        if (res === 'refresh') {
          this.pageNo = 1
          this.getData()
        }
      })
    },
    //添加备注
    clickAddRemark() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      this.remark = ''
      this.visibleRemark = true
    },
    //保存备注
    clickSaveRemark() {
      if (this.$method.isEmpty(this.remark)) {
        this.$message.error('请输入备注')
        return
      }
      this.$postRequest('/admin/order/jieAddRemark', {
        ids: this.ids,
        remark: this.remark,
        type: 1,//1接方 2审方 3执行入库 4调剂添加备注, 5复核添加备注, 6泡药，7煎药，8包装，9发货
      }).then((res) => {
        if (res) {
          this.visibleRemark = false
          this.remark = ''
          this.$message.success('添加成功')
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //打印调配单
    clickPrintTransfer() {
      if (this.ids.length === 0) {
        this.$message.error("请先选择订单")
        return
      }
      this.$refs.printPage.getDetail()
    },
    //打印调配条形码
    clickPrintBarCode() {
      if (this.ids.length === 0) {
        this.$message.error("请先选择订单")
        return
      }
      this.showCodeDrawer = true
    },
    //打印标签
    clickPrintLabel() {
      if (this.ids.length === 0) {
        this.$message.error("请先选择订单")
        return
      }
      this.showLabelDrawer = true
    },
    //导出处方
    clickExport() {
      let token = sessionStorage.getItem('token')
      let param = {
        orderNo: this.number,
        patientName: this.name,
        hospitalName: this.hospital,
        mechName: this.organization,
        status: this.tabIndex === 0 ? 1 : this.tabIndex === 1 ? 90 : '',
        //订单状态 0 已作废 1 待接方列表 2 待审方
        // 90接方查询，91审方查询，92待入库列表，93带调剂列表，
        // 94调剂查询 ，95待复核列表 96复核查询, 97带泡药列表 98泡药查询 99带煎药列表 100煎药查询, 101 带包装列表，
        // 102包装查询，103待发货列表，104发货查询，105处方查询
        prescriptionStatus: this.tabIndex === 0 ? 11 : this.selectState,
        //v27 处方状态，0待审方，1待复核，2代调剂，3带泡药，4正在泡药，5代煎药，6正在煎药，
        // 7带包装，8正在包装，9待发货，10已发货，11待接方，12接方作废，13审方作废，14调剂作废，15接方通过，16审方通过，
        // 17待入库，18已入库，19调剂完成，20复核驳回，21复核完成
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        dateType: this.tabIndex === 0 ? '' : this.selectDateType,//v27 日期类型，0传方，1操作, 2泡药煎药时间
        pageNumber: this.pageNo,
        token: token,
      }
      let url = this.$baseUrl + '/admin/order/orderExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //导出药品
    clickExportMedicine() {
      let token = sessionStorage.getItem('token')
      let param = {
        orderNo: this.number,
        patientName: this.name,
        hospitalName: this.hospital,
        mechName: this.organization,
        status: this.tabIndex === 0 ? 1 : this.tabIndex === 1 ? 90 : '',
        //订单状态 0 已作废 1 待接方列表 2 待审方
        // 90接方查询，91审方查询，92待入库列表，93带调剂列表，
        // 94调剂查询 ，95待复核列表 96复核查询, 97带泡药列表 98泡药查询 99带煎药列表 100煎药查询, 101 带包装列表，
        // 102包装查询，103待发货列表，104发货查询，105处方查询
        prescriptionStatus: this.tabIndex === 0 ? 11 : this.selectState,
        //v27 处方状态，0待审方，1待复核，2代调剂，3带泡药，4正在泡药，5代煎药，6正在煎药，
        // 7带包装，8正在包装，9待发货，10已发货，11待接方，12接方作废，13审方作废，14调剂作废，15接方通过，16审方通过，
        // 17待入库，18已入库，19调剂完成，20复核驳回，21复核完成
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        dateType: this.tabIndex === 0 ? '' : this.selectDateType,//v27 日期类型，0传方，1操作, 2泡药煎药时间
        pageNumber: this.pageNo,
        token: token,
      }
      let url = this.$baseUrl + '/admin/order/drugExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //导出处方及药品
    clickExportAll() {
      let token = sessionStorage.getItem('token')
      let param = {
        orderNo: this.number,
        patientName: this.name,
        hospitalName: this.hospital,
        mechName: this.organization,
        status: this.tabIndex === 0 ? 1 : this.tabIndex === 1 ? 90 : '',
        //订单状态 0 已作废 1 待接方列表 2 待审方
        // 90接方查询，91审方查询，92待入库列表，93带调剂列表，
        // 94调剂查询 ，95待复核列表 96复核查询, 97带泡药列表 98泡药查询 99带煎药列表 100煎药查询, 101 带包装列表，
        // 102包装查询，103待发货列表，104发货查询，105处方查询
        prescriptionStatus: this.tabIndex === 0 ? 11 : this.selectState,
        //v27 处方状态，0待审方，1待复核，2代调剂，3带泡药，4正在泡药，5代煎药，6正在煎药，
        // 7带包装，8正在包装，9待发货，10已发货，11待接方，12接方作废，13审方作废，14调剂作废，15接方通过，16审方通过，
        // 17待入库，18已入库，19调剂完成，20复核驳回，21复核完成
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        dateType: this.tabIndex === 0 ? '' : this.selectDateType,//v27 日期类型，0传方，1操作, 2泡药煎药时间
        pageNumber: this.pageNo,
        token: token,
      }
      let url = this.$baseUrl + '/admin/order/orderAndDrugExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //检查数据的完整性
    checkData() {
      if (this.$method.isEmpty(this.detailItem.hospitalName)) {
        this.$message.error('请选择医院')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.doctorName)) {
        this.$message.error('请输入开方医生')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.patientName)) {
        this.$message.error('请输入患者姓名')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.patientAge)) {
        this.$message.error('请输入患者年龄')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.patientSex)) {
        this.$message.error('请选择患者性别')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.deliveryCompany)) {
        this.$message.error('请选择配送方式')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.deliveryType)) {
        this.$message.error('请选择运费方式')
        return false
      }
      if (this.detailItem.deliveryCompany !== '厂内配送') {
        if (this.$method.isEmpty(this.detailItem.receiveName)) {
          this.$message.error('请输入收件人')
          return false
        }
        if (this.$method.isEmpty(this.detailItem.receiveMobile)) {
          this.$message.error('请输入收件电话')
          return false
        }
        if (this.detailItem.receiveMobile.length !== 11) {
          this.$message.error('请输入11位收件电话')
          return false
        }
        if (this.$method.isEmpty(this.detailItem.receiveAddress)) {
          this.$message.error('请输入收件地址')
          return false
        }
      }
      if (this.$method.isEmpty(this.detailItem.processType)) {
        this.$message.error('请选择加工类型')
        return false
      }
      if (this.detailItem.processType.indexOf('汤剂') === -1 && this.$method.isEmpty(this.detailItem.packageType)) {
        this.$message.error('请选择包装类型')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.doseNums)) {
        this.$message.error('请输入剂数')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.way1)) {
        this.$message.error('请选择用法')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.isDecoctionShow)) {
        this.$message.error('请选择是否代煎')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.packageNums)) {
        this.$message.error('请输入包装量')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.frequency)) {
        this.$message.error('请输入次数')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.createTime)) {
        this.$message.error('请选择下单时间')
        return false
      }
      if (this.$method.isEmpty(this.detailItem.drugs) || this.detailItem.drugs.length === 0) {
        this.$message.error('请添加药品信息')
        this.$nextTick(() => {
          document.getElementById("inputScrollDiv").scrollIntoView({
            behavior: "instant",
            block: "end",
          })
        })
        return false
      }
      for (let item of this.detailItem.drugs) {
        if (this.$method.isEmptyOrZero(item.nums)) {
          this.$message.error(item.name + '药品数量不能为空')
          this.$nextTick(() => {
            document.getElementById("inputScrollDiv").scrollIntoView({
              behavior: "instant",
              block: "end",
            })
          })
          return false
        }
      }
      return true
    },
    //保存处方
    clickSavePre() {
      if (this.isSaving) {
        this.$message.warning('保存中请稍后')
        return
      }
      if (this.checkData()) {
        this.isSaving = true
        this.detailItem.isDecoction = this.detailItem.isDecoctionShow === '代煎'
        this.detailItem.takeMethod = this.detailItem.way1 + (this.$method.isEmpty(this.detailItem.way2) ? '' : '(' + this.detailItem.way2 + ')')
        this.detailItem.saveType = 1;//保存类型，1保存，2保存并接方
        this.$postRequest('/admin/order/addOrder', this.detailItem).then((res) => {
          if (res) {
            this.$message.success('保存成功')
            this.detailItem = {
              patientSex: '男',
              isDecoctionShow: '代煎',
              deliveryType: 1,
              drugs: [],
              drugInputDisabled: true,
            }
            this.detailItem.createTime = this.$method.getNowTime()
          }
          this.isSaving = false
        }).catch((error) => {
          this.isSaving = false
          console.log(error)
        })
      }
    },
    //保存并接方
    clickSaveAndReceive() {
      if (this.isSaving) {
        this.$message.warning('保存中请稍后')
        return
      }
      if (this.checkData()) {
        this.isSaving = true
        this.detailItem.isDecoction = this.detailItem.isDecoctionShow === '代煎'
        this.detailItem.takeMethod = this.detailItem.way1 + (this.$method.isEmpty(this.detailItem.way2) ? '' : '(' + this.detailItem.way2 + ')')
        this.detailItem.saveType = 2;//保存类型，1保存，2保存并接方
        this.$postRequest('/admin/order/addOrder', this.detailItem).then((res) => {
          if (res) {
            this.$message.success('保存成功')
            this.detailItem = {
              patientSex: '男',
              isDecoctionShow: '代煎',
              deliveryType: 1,
              drugs: [],
              drugInputDisabled: true,
            }
            this.detailItem.createTime = this.$method.getNowTime()
          }
          this.isSaving = false
        }).catch((error) => {
          this.isSaving = false
          console.log(error)
        })
      }
    },
    //批量导入处方
    clickImportPre() {
      this.downloadUrl = this.$axios.defaults.baseURL + '/template/批量导入处方.xlsx'
      this.visibleImport = true
      this.bus.$off('importSuccess')
      this.bus.$on('importSuccess', res => {
        this.visibleImport = false
      })
    },
    //一键清空
    clickClearAll() {
      this.$confirm("您确定要清空吗？不可恢复", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.detailItem = {
          patientSex: '男',
          isDecoctionShow: '代煎',
          deliveryType: 1,
          drugs: [],
          drugInputDisabled: true,
        }
        this.detailItem.createTime = this.$method.getNowTime()
      }).catch(() => {
      });
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/order/page', {
        orderNo: this.number,
        patientName: this.name,
        hospitalName: this.hospital,
        mechName: this.organization,
        status: this.tabIndex === 0 ? 1 : this.tabIndex === 1 ? 90 : '',
        //订单状态 0 已作废 1 待接方列表 2 待审方
        // 90接方查询，91审方查询，92待入库列表，93带调剂列表，
        // 94调剂查询 ，95待复核列表 96复核查询, 97带泡药列表 98泡药查询 99带煎药列表 100煎药查询, 101 带包装列表，
        // 102包装查询，103待发货列表，104发货查询，105处方查询
        prescriptionStatus: this.tabIndex === 0 ? 11 : this.selectState,
        //v27 处方状态，0待审方，1待复核，2代调剂，3带泡药，4正在泡药，5代煎药，6正在煎药，
        // 7带包装，8正在包装，9待发货，10已发货，11待接方，12接方作废，13审方作废，14调剂作废，15接方通过，16审方通过，
        // 17待入库，18已入库，19调剂完成，20复核驳回，21复核完成
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        dateType: this.tabIndex === 0 ? '' : this.selectDateType,//v27 日期类型，0传方，1操作, 2泡药煎药时间
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取医院下拉
    getHospitalArray() {
      this.$getRequest('/admin/hospital/list', {}).then((res) => {
        if (res) {
          this.hospitalArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取下拉数据
    getDict() {
      this.$getRequest('/admin/systemConfig/getDict', {}).then((res) => {
        if (res) {
          this.wayArray1 = res.data.takeWayList
          this.wayArray2 = res.data.mealList
          this.wayArray = res.data.wayList
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取煎药方案
    getPlanArray() {
      let isDecoctionShow = this.detailItem.isDecoctionShow
      let name = this.detailItem.processType
      if (name === '汤剂') {
        name += '(' + isDecoctionShow + ')'
      }
      this.$postFormRequest('/admin/systemConfig/getBrDecoctScheme', {
        name: name
      }).then((res) => {
        if (res) {
          this.planArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取库房列表
    getHouseList() {
      this.detailItem.pharmacyId = ''
      this.detailItem.drugs = []
      let hospitalId = this.hospitalArray.filter(item => {
        return item.name === this.detailItem.hospitalName
      })[0].id
      this.detailItem.hospitalId = hospitalId
      this.$getRequest('/admin/hospital/gePharmacy', {
        id: hospitalId
      }).then((res) => {
        if (res) {
          this.houseArray = res.data
          if (this.houseArray.length > 0) {
            this.detailItem.pharmacyId = this.houseArray[0].id
            this.getPharmacyDrug()
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //根据库房id查询药品
    getPharmacyDrug() {
      this.detailItem.drugInputDisabled = true
      this.$getRequest('/admin/stock/getPharmacyDrug', {
        pharmacyId: this.detailItem.pharmacyId
      }).then((res) => {
        if (res) {
          this.drugArray = res.data
        }
        this.detailItem.drugInputDisabled = false
      }).catch((error) => {
        this.detailItem.drugInputDisabled = false
        console.log(error)
      })
    },
    searchDrug(queryString, cb) {
      let restaurants = this.drugArray
      if (restaurants.length === 0) {
        this.$message.error('药品加载中，请稍后...')
      }
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      for (let i = 0; i < results.length; i++) {
        results[i].index = i
      }
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        // return (restaurant.name === queryString || (restaurant.pyName && restaurant.pyName.toLowerCase() === queryString.toLowerCase()));
        return (restaurant.name.match(queryString) || (restaurant.pyName && restaurant.pyName.toLowerCase().match(queryString.toLowerCase())));
      };
    },
    //点击药品选择
    clickSelectDrug(row) {
      this.detailItem.searchDrug = ''
      if (this.contains(this.detailItem.drugs, row)) {
        this.$message.error("不能添加重复药品")
      } else {
        row.nums = ''
        row.pharmacyId = 0
        row.unit = row.saleUnit
        this.detailItem.drugs.push(row)
        this.$nextTick(() => {
          document.getElementById("inputScrollDiv").scrollIntoView({
            behavior: "instant",
            block: "end",
          })
        })
      }
    },
    contains(a, obj) {
      for (let i = 0; i < a.length; i++) {
        if (a[i].id === obj.id || a[i].temId === obj.id) {
          return true;
        }
      }
      return false;
    },
    //获取快递公司下拉
    getDelivery() {
      this.$getRequest('/admin/dict/getDelivery', {}).then((res) => {
        if (res) {
          this.companyArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    provinceChange(e) {
      this.detailItem.receiveCity = ''
      this.detailItem.receiveRegion = ''
      this.cityArray = []
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.provinceArray.length; i++) {
          let item = this.provinceArray[i]
          if (e === item.n) {
            this.cityArray = item.c
          }
        }
      }
    },
    cityChange(e) {
      this.detailItem.receiveRegion = ''
      this.areaArray = []
      if (e && e !== '') {
        for (let i = 0; i < this.cityArray.length; i++) {
          let item = this.cityArray[i]
          if (e === item.n) {
            this.areaArray = item.c
          }
        }
      }
    },
    //获取包装类型
    getPackageType() {
      this.$getRequest('/admin/systemConfig/getPackageType', {
        name: this.detailItem.processType
      }).then((res) => {
        if (res) {
          this.packageTypeArray = []
          for (let i = 0; i < res.data.length; i++) {
            this.packageTypeArray.push({
              id: i,
              name: res.data[i],
            })
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.receiveManage {
  height: 100%;

  .tab-div {
    background: #FFFFFF;
    margin: 20px 20px 0 20px;
    padding: 20px 0 0 0;

    .tab-item {
      padding: 0 20px;
      cursor: pointer;

      .tab-title {
        font-size: 18px;
        padding-bottom: 20px;

        &-active {
          color: #215AA0;
          font-weight: bold;
        }
      }

      .tab-line {
        width: 100%;
        height: 2px;
        background: #FFFFFF;
        border-radius: 1px;

        &-active {
          background: #215AA0;
        }
      }
    }
  }

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;

    .red-point {
      width: 10px;
      height: 10px;
      background: #F46161;
      border-radius: 50%;
    }

    .red-point1 {
      width: 10px;
      height: 10px;
    }

    .img-sign {
      width: 90px;
      height: 30px;
    }

    .title1 {
      font-size: 22px;
      color: #252525;
    }

    .line-grey-shu {
      background: #E5E9ED;
      margin: 0 25px;
    }

    .left-div {
      width: 110px;
      text-align: right;
      margin-right: 10px;
    }

    .item-drug {
      width: 370px;
      height: 60px;
      background: #F5F6F8;
      padding: 20px;
      border-radius: 4px;
      margin-right: 10px;
      margin-bottom: 10px;
      position: relative;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .img-delete {
        width: 30px;
        height: 30px;
        padding: 5px;
        position: absolute;
        top: 0;
        right: 0;
        object-fit: scale-down;
        cursor: pointer;
      }
    }
  }
}

.dialog-title {
  font-size: 18px;
  color: #FFFFFF;
  margin-left: 20px;
}

.btn-next {
  width: 95px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  border: 1px solid #FFFFFF;
  border-radius: 17px;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
  margin-left: 20px;
}

.search-drug-title {
  width: 200px;
  font-size: 18px;
  font-weight: bold;
  background-color: #F5F6F8;
  color: #7B8CA0;
  text-align: center;
  border-right: 1px solid #E5E9ED;
  border-bottom: 1px solid #E5E9ED;
}

.search-drug-content {
  width: 200px;
  font-size: 18px;
  text-align: center;
  border-right: 1px solid #E5E9ED;
  border-bottom: 1px solid #E5E9ED;
}
</style>
